import React from "react";
import { observer } from "mobx-react";
import { MenuItemRevenueStats } from "../../../../../../services/stats/models";
import TopItemsCard from "./TopItemsCard";
import { Space } from "../../../../../../common/components/libs";


const TopItemsCards = ({ result }: { result: MenuItemRevenueStats [] }) => {


    return (
        <>
            {
                result.map(item => {
                    return <>
                        <TopItemsCard item={item}/>
                        <Space size={10}/>
                    </>;
                })
            }
        </>
    );
};

export default observer(TopItemsCards);
